module.exports = __webpack_public_path__ + "img/generated-1772420741228.75f937e6.png";